// Explore → Bookshelf (059). Every item is a link to the publisher's site.
//
// ⚠️ BOOKSHELF_KINDS mirrors the `kind` allowlist in 059's table CHECK and in
// admin_save_bookshelf_item. Change all three together.
// ⚠️ The *_MAX numbers mirror the RPC caps, which RAISE (not truncate).
export const BOOKSHELF_KINDS = [
  { id: 'guide', label: 'Guide', color: '#4D775E' },
  { id: 'program', label: 'Program', color: '#2E5566' },
  { id: 'newsletter', label: 'Newsletter', color: '#A45945' },
  { id: 'article', label: 'Article', color: '#8A5A2B' },
  { id: 'book', label: 'Book', color: '#5B4A7A' },
  { id: 'course', label: 'Course', color: '#3F6E7A' },
  { id: 'video', label: 'Video', color: '#6B4A4A' },
];

export const BOOKSHELF_MAX = {
  title: 200,
  edition: 80,
  shelf: 40,
  publisher: 100,
  publisherShort: 12,
  summary: 400,
  note: 200,
  highlightsLabel: 60,
  highlights: 12,
  highlightTitle: 150,
  url: 500,
};

export const kindInfo = (id) =>
  BOOKSHELF_KINDS.find((k) => k.id === id) || { id, label: id, color: '#4D775E' };

export const normalizeBookshelfItem = (r) => ({
  id: r.id,
  title: r.title,
  edition: r.edition || null,
  kind: r.kind,
  shelf: r.shelf,
  publisher: r.publisher,
  publisherShort: r.publisher_short,
  summary: r.summary,
  note: r.note || null,
  highlightsLabel: r.highlights_label || null,
  highlights: Array.isArray(r.highlights) ? r.highlights : [],
  url: r.url,
  sponsor: !!r.sponsor,
  sortOrder: r.sort_order ?? null,
  active: r.active !== undefined ? !!r.active : true,
});

// Shelves in the order their first item appears, so sort_order also orders
// the shelves.
export const groupByShelf = (items) => {
  const shelves = [];
  const byName = new Map();
  for (const item of items) {
    if (!byName.has(item.shelf)) {
      const shelf = { name: item.shelf, items: [] };
      byName.set(item.shelf, shelf);
      shelves.push(shelf);
    }
    byName.get(item.shelf).items.push(item);
  }
  return shelves;
};

// "Read on nadsp.org" / "Learn more on nadsp.org". Derived, so the button can
// never name a different site from the one it opens.
export const linkLabel = (item) => {
  let host = '';
  try {
    host = new URL(item.url).hostname.replace(/^www\./, '');
  } catch {
    return 'Open';
  }
  return `${item.kind === 'program' || item.kind === 'course' ? 'Learn more' : 'Read'} on ${host}`;
};
